// import React from "react";
// import Navbar from "../../Components/Navbar";
// import Header from "../../Components/Header";
// import { Container, Typography } from "@mui/material";
// import Footer from "../../Components/Footer";
// import CallToEnroll from "../../Components/CallToEnroll";
// import PageTitle from "../../Components/PageTitle";
// import RIMCBanner from "../../assets/RIMC.png";

// const RIMC = () => {
//   return (
//     <>
//       <Navbar />
//       <PageTitle
//         title="RIMC Coaching - Shree Mangalam School"
//         description="Join Shree Mangalam School for the best RIMC coaching. Expert faculty, updated syllabus, mock tests, and personal mentorship to crack the RIMC entrance exam."
//         url="/RIMC"
//         keywords="RIMC coaching, RIMC entrance exam, Rashtriya Indian Military College preparation, best RIMC classes, Shree Manglam RIMC coaching"
//       />

//       <Header image={RIMCBanner} alt={"RIMC Coaching Banner"} />

//       <Container sx={{ mb: 5, mt: 5 }}>
//         <Typography
//           variant="h5"
//           sx={{
//             fontFamily: "Montserrat, sans-serif",
//             fontOpticalSizing: "auto",
//             fontStyle: "normal",
//             fontSize: "30px",
//             letterSpacing: 1,
//             color: "#065A79",
//             fontWeight: "bold",
//           }}
//           gutterBottom
//         >
//           Rashtriya Indian Military College (RIMC)
//         </Typography>
//         <Typography
//           variant="body1"
//           sx={{
//             mt: 3,
//             fontFamily: "Montserrat, sans-serif",
//             fontOpticalSizing: "auto",
//             fontStyle: "normal",
//             letterSpacing: 1,
//             lineHeight: "1.8rem",
//           }}
//         >
//           At Shree Mangalam School, we take pride in offering a
//           specialized preparation program for the Rashtriya Indian Military
//           College (RIMC) entrance exam — one of the most prestigious and
//           challenging tests for young aspirants aiming for a career in the armed
//           forces. Our goal is to mentor and train students from jaipur-gudha state highway (Just on by pass) gudha gorji,
//           and nearby regions to compete at a national level with
//           confidence and discipline.
//         </Typography>

//         <Typography
//           variant="body1"
//           sx={{
//             mt: 2,
//             fontFamily: "Montserrat, sans-serif",
//             fontOpticalSizing: "auto",
//             fontStyle: "normal",
//             letterSpacing: 1,
//             lineHeight: "1.8rem",
//           }}
//         >
//           Our RIMC coaching program includes intensive academic training in
//           Mathematics, English, and General Knowledge, alongside regular mock
//           tests, interview preparation, and personality development sessions. We
//           follow a rigorous and structured approach that not only strengthens
//           subject knowledge but also develops the leadership qualities and
//           discipline expected from future cadets. With experienced faculty, a
//           military-style focus on values, and consistent progress tracking, we
//           ensure every child is prepared both mentally and emotionally to crack
//           the RIMC entrance.
//         </Typography>

//         <Typography
//           variant="body1"
//           sx={{
//             mt: 2,
//             fontFamily: "Montserrat, sans-serif",
//             fontOpticalSizing: "auto",
//             fontStyle: "normal",
//             letterSpacing: 1,
//             lineHeight: "1.8rem",
//           }}
//         >
//           We believe that with the right guidance, even students from rural
//           areas can achieve big dreams. At Shree Mangalam School, we are
//           committed to turning ambition into achievement by preparing students
//           not just for selection — but for a life of honor, service, and
//           excellence.
//         </Typography>

//         <Typography
//           variant="body1"
//           sx={{
//             mt: 2,
//             fontFamily: "Montserrat, sans-serif",
//             fontOpticalSizing: "auto",
//             fontStyle: "normal",
//             letterSpacing: 1,
//             lineHeight: "1.8rem",
//           }}
//         >
//           Give your child the edge they deserve. Enroll in our Rashtriya Indian
//           Military College (RIMC) and become part of a growing success story at
//           Shree Mangalam School.
//         </Typography>
//       </Container>
//       <CallToEnroll />
//       <Footer />
//     </>
//   );
// };

// export default RIMC;

import React from "react";
import Navbar from "../../Components/Navbar";
import Header from "../../Components/Header";
import { 
  Container, 
  Typography, 
  Box, 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TableRow, 
  Paper
} from "@mui/material";
import Footer from "../../Components/Footer";
import CallToEnroll from "../../Components/CallToEnroll";
import PageTitle from "../../Components/PageTitle";
import RIMCBanner from "../../assets/RIMC.png";

const RIMC = () => {
  const eligibilityCriteria = [
    // { 
    //   parameter: "Age Limit", 
    //   details: "11½ to 13 years as on 1st July of admission year",
    //   class: "Class 8"
    // },
    { 
    parameter: "Age Limit", 
    details: "11½ to 13 years as on 1st July of admission year (e.g., For 2025: born between 02 July 2012 - 01 January 2014)",
    class: "Class 8"
  },
    { 
      parameter: "Educational Qualification", 
      details: "Studying in or passed Class 7 from a recognized school",
      class: "Class 7"
    },
    { 
      parameter: "Nationality", 
      details: "Indian citizens only",
      class: "All"
    },
    { 
      parameter: "Medical Standards", 
      details: "Must meet strict medical fitness criteria",
      class: "All"
    },
    { 
      parameter: "Written Exam", 
      details: "Written Exam: English, Mathematics, General Knowledge",
      class: "Class 8"
    },
    { 
      parameter: "Interview", 
      details: "Personality test and interview at RIMC Dehradun",
      class: "Class 8"
    },
  ];

  return (
    <>
      <Navbar />
      <PageTitle
        title="RIMC Coaching - Shree Mangalam School"
        description="Join Shree Mangalam School for the best RIMC coaching. Expert faculty, updated syllabus, mock tests, and personal mentorship to crack the RIMC entrance exam."
        url="/RIMC"
        keywords="RIMC coaching, RIMC entrance exam, Rashtriya Indian Military College preparation, best RIMC classes, Shree Manglam RIMC coaching"
      />

      <Header image={RIMCBanner} alt={"RIMC Coaching Banner"} />

      <Container sx={{ mb: 5, mt: 5 }}>
        <Typography
          variant="h5"
          sx={{
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            fontSize: "30px",
            letterSpacing: 1,
            color: "#065A79",
            fontWeight: "bold",
          }}
          gutterBottom
        >
          Rashtriya Indian Military College (RIMC)
        </Typography>
        <Typography
          variant="body1"
          sx={{
            mt: 3,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          At Shree Mangalam School, we take pride in offering a
          specialized preparation program for the Rashtriya Indian Military
          College (RIMC) entrance exam — one of the most prestigious and
          challenging tests for young aspirants aiming for a career in the armed
          forces. Our goal is to mentor and train students from jaipur-gudha state highway (Just on by pass) gudha gorji,
          and nearby regions to compete at a national level with
          confidence and discipline.
        </Typography>

        {/* Eligibility Criteria Section - Single Responsive Table */}
        <Box sx={{ mt: 6, mb: 4 }}>
          <Typography
            variant="h5"
            sx={{
              fontFamily: "Montserrat, sans-serif",
              fontOpticalSizing: "auto",
              fontStyle: "normal",
              fontSize: "26px",
              letterSpacing: 1,
              color: "#AD1C86",
              fontWeight: "bold",
              mb: 3,
            }}
          >
            RIMC Entrance Exam Eligibility Criteria
          </Typography>
          
          {/* Single Responsive Table for all devices */}
          <Box sx={{ width: '100%', overflowX: "auto" }}>
            <TableContainer 
              component={Paper} 
              sx={{ 
                borderRadius: 2,
                boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
                mb: 3,
                minWidth: 300 // Minimum width for mobile
              }}
            >
              <Table sx={{ 
                minWidth: 300,
                '& th, & td': {
                  padding: { xs: '12px 8px', sm: '16px' } // Responsive padding
                }
              }}>
                <TableHead>
                  <TableRow sx={{ bgcolor: '#065A79' }}>
                    <TableCell 
                      sx={{ 
                        color: 'white', 
                        fontWeight: 'bold',
                        fontSize: { xs: '14px', sm: '16px' },
                        fontFamily: 'Montserrat, sans-serif',
                        whiteSpace: 'nowrap'
                      }}
                    >
                      Parameter
                    </TableCell>
                    <TableCell 
                      sx={{ 
                        color: 'white', 
                        fontWeight: 'bold',
                        fontSize: { xs: '14px', sm: '16px' },
                        fontFamily: 'Montserrat, sans-serif'
                      }}
                    >
                      Details
                    </TableCell>
                    <TableCell 
                      sx={{ 
                        color: 'white', 
                        fontWeight: 'bold',
                        fontSize: { xs: '14px', sm: '16px' },
                        fontFamily: 'Montserrat, sans-serif',
                        whiteSpace: 'nowrap'
                      }}
                    >
                      Class
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {eligibilityCriteria.map((row, index) => (
                    <TableRow 
                      key={index}
                      sx={{ 
                        '&:nth-of-type(odd)': { bgcolor: '#F8F9FA' },
                        '&:hover': { bgcolor: '#F0F7FF' }
                      }}
                    >
                      <TableCell 
                        component="th" 
                        scope="row"
                        sx={{ 
                          fontWeight: 'bold',
                          fontFamily: 'Montserrat, sans-serif',
                          color: '#065A79',
                          whiteSpace: 'nowrap',
                          fontSize: { xs: '13px', sm: 'inherit' }
                        }}
                      >
                        {row.parameter}
                      </TableCell>
                      <TableCell 
                        sx={{ 
                          fontFamily: 'Montserrat, sans-serif',
                          lineHeight: '1.6',
                          fontSize: { xs: '13px', sm: 'inherit' }
                        }}
                      >
                        {row.details}
                      </TableCell>
                      <TableCell 
                        sx={{ 
                          fontFamily: 'Montserrat, sans-serif',
                          fontWeight: 'medium',
                          fontSize: { xs: '13px', sm: 'inherit' }
                        }}
                      >
                        {row.class}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>

          <Box sx={{ mt: 3 }}>
            <Paper
              elevation={0}
              sx={{
                p: 2,
                borderRadius: 1,
                bgcolor: '#F8F9FA',
                borderLeft: '4px solid #AD1C86'
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  fontFamily: "Montserrat, sans-serif",
                  fontOpticalSizing: "auto",
                  fontStyle: "normal",
                  letterSpacing: 0.5,
                  lineHeight: "1.6rem",
                  color: "#555",
                  fontSize: { xs: '13px', sm: 'inherit' }
                }}
              >
                <strong>Note:</strong> RIMC has a highly competitive selection process with limited seats. 
                Students must clear written exam, interview, and medical tests. Age calculation is 
                strict - as on 1st July of the admission year.
              </Typography>
            </Paper>
          </Box>
        </Box>

        <Typography
          variant="body1"
          sx={{
            mt: 4,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          Our RIMC coaching program includes intensive academic training in
          Mathematics, English, and General Knowledge, alongside regular mock
          tests, interview preparation, and personality development sessions. We
          follow a rigorous and structured approach that not only strengthens
          subject knowledge but also develops the leadership qualities and
          discipline expected from future cadets. With experienced faculty, a
          military-style focus on values, and consistent progress tracking, we
          ensure every child is prepared both mentally and emotionally to crack
          the RIMC entrance.
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          We believe that with the right guidance, even students from rural
          areas can achieve big dreams. At Shree Mangalam School, we are
          committed to turning ambition into achievement by preparing students
          not just for selection — but for a life of honor, service, and
          excellence.
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          Give your child the edge they deserve. Enroll in our Rashtriya Indian
          Military College (RIMC) and become part of a growing success story at
          Shree Mangalam School.
        </Typography>
      </Container>
      <CallToEnroll />
      <Footer />
    </>
  );
};

export default RIMC;